var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33 4.67001H8.66V3.34001C8.66 1.50001 7.17 0.0100098 5.33 0.0100098C3.49 0.0100098 2 1.49001 2 3.33001V4.66001H1.33C0.59 4.66001 0 5.26001 0 5.99001V12.66C0 13.4 0.6 13.99 1.33 13.99H9.33C10.07 13.99 10.66 13.39 10.66 12.66V6.00001C10.66 5.26001 10.06 4.67001 9.33 4.67001ZM5.33 10.74C4.59 10.74 4 10.14 4 9.41001C4 8.67001 4.6 8.08001 5.33 8.08001C6.07 8.08001 6.66 8.68001 6.66 9.41001C6.66 10.15 6.06 10.74 5.33 10.74ZM7.4 4.67001H3.27V3.34001C3.24 2.20001 4.15 1.25001 5.29 1.23001C6.43 1.21001 7.38 2.11001 7.4 3.25001C7.4 3.28001 7.4 3.31001 7.4 3.34001V4.67001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.67,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/Cvc.f2ac675226d5c9093257f8cc4d00700e.svg";
export { ForwardRef as ReactComponent };